<template>
  <Transition name="fade-fast">
    <form
      v-if="ready"
      class="riddle__question"
      action=""
      method="post"
      @submit.prevent="validate"
      novalidate
    >
      <FormInput
        :hint="riddle.hint"
        :label="$t('answer')"
        :model-value="answer"
        name="answer"
        :validate="false"
        @update:modelValue="(newValue) => (answer = newValue.value)"
      />
      <button
        v-if="!valid && error.count < maxTries"
        class="button"
        type="submit"
        :disabled="answer === ''"
        :title="$beet.options.hunt.labels.riddle.submit"
      >
        {{ $beet.options.hunt.labels.riddle.submit }}
      </button>
      <button
        v-if="error.count === maxTries"
        class="button"
        type="button"
        @click.stop="navigateToNextRiddle"
      >
        {{ $beet.options.hunt.labels.riddle.next }}
      </button>
      <RiddleValid :visible="valid" />
      <RiddleError
        :max="error.count === maxTries"
        :valid-answer="riddle.answers[0]"
        :visible="error.current"
      />
      <RiddleConfetti v-if="adventureCompleted" @animation-completed="navigateToCongratulations" />
    </form>
  </Transition>
</template>

<script>
import { FormInput } from '@/components/form'
import { localizedRouteName } from '@/helpers'
import { UsesRoutesMixin } from '@/mixins'

import RiddleConfetti from './RiddleConfetti.vue'
import RiddleError from './RiddleError.vue'
import RiddleValid from './RiddleValid.vue'

export default {
  name: 'RiddleQuestion',
  mixins: [UsesRoutesMixin],
  components: { FormInput, RiddleConfetti, RiddleError, RiddleValid },
  props: {
    maxTries: {
      type: Number,
      default: 3,
    },
    ready: {
      type: Boolean,
      required: true,
    },
    riddle: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      adventureCompleted: false,
      answer: '',
      complete: false,
      error: {
        count: 0,
        current: false,
      },
      valid: false,
    }
  },
  methods: {
    addError() {
      this.error.current = true
      this.error.count++
      this.saveErrorCount()
    },
    completeRiddle(success = true) {
      this.$store.dispatch('saveRiddle', {
        riddle: this.$store.state.riddle.current,
        success: success,
      })
    },
    navigateToCongratulations() {
      this.$router.push({ name: localizedRouteName(this.ROUTES.HUNT.CONGRATULATIONS) })
    },
    navigateToNextRiddle() {
      if (this.$store.state.riddle.current) {
        return this.$router.push({
          name: localizedRouteName(this.ROUTES.HUNT.RIDDLE),
          params: { id: this.$store.state.riddle.current },
        })
      }

      this.adventureCompleted = true
    },
    resetError() {
      this.error.current = false
    },
    resetErrorCount() {
      this.error.count = 0
      localStorage.removeItem(`riddle_error_count_${this.riddle.id}`)
    },
    saveErrorCount() {
      localStorage.setItem(`riddle_error_count_${this.riddle.id}`, this.error.count.toString())
    },
    validate() {
      this.resetError()
      this.valid = this.riddle.answers.includes(this.answer.toLowerCase())

      if (this.valid) {
        this.completeRiddle()
        return setTimeout(this.navigateToNextRiddle, 2000)
      }

      this.answer = ''
      this.addError()

      if (this.error.count < this.maxTries) setTimeout(this.resetError, 1500)
      else if (this.error.count === this.maxTries) this.completeRiddle(false)
    },
  },
  mounted() {
    this.error.count = parseInt(localStorage.getItem(`riddle_error_count_${this.riddle.id}`) ?? '0')
  },
  watch: {
    $route() {
      this.resetErrorCount()
    },
  },
}
</script>
